export const PAYMENT_METHODS_QUERY = `
  query GetPaymentMethods {
    paymentMethods {
      id
      stripeId
      type
      cardBrand
      cardExpMonth
      cardExpYear
      cardLast4
    }
  }
`;

export const PACKAGES_QUERY = `
  query GetPackages {
    packages {
      id
      credits
      amount
      currency
    }
  }
`;

export const SUBSCRIPTIONS_QUERY = `
  query GetSubscriptions {
    subscriptions {
      id
      name
      description
      type
      frequency
      amount
      currency
      credits
    }
  }
`;
